// @ts-strict-ignore
import React from 'react';

import { View } from '@actual-app/components/view';
import type { RuleEntity } from '@actual-app/core/types/models';

import { RuleRow } from './RuleRow';

type RulesListProps = {
  rules: RuleEntity[];
  nocturneLayout?: boolean;
  orderById?: ReadonlyMap<string, number>;
  selectedItems: Set<string>;
  hoveredRule?: string;
  onHover?: (id: string | null) => void;
  onEditRule?: (rule: RuleEntity) => void;
  onDeleteRule?: (rule: RuleEntity) => void;
};

export function RulesList({
  rules,
  nocturneLayout,
  orderById,
  selectedItems,
  hoveredRule,
  onHover,
  onEditRule,
  onDeleteRule,
}: RulesListProps) {
  if (rules.length === 0) {
    return null;
  }

  return (
    <View>
      {rules.map((rule, index) => {
        const hovered = hoveredRule === rule.id;
        const selected = selectedItems.has(rule.id);

        return (
          <RuleRow
            key={rule.id}
            rule={rule}
            nocturneLayout={nocturneLayout}
            order={orderById?.get(rule.id) ?? index + 1}
            hovered={hovered}
            selected={selected}
            onHover={onHover}
            onEditRule={onEditRule}
            onDeleteRule={onDeleteRule}
          />
        );
      })}
    </View>
  );
}
